(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.weaver_switchers = {

    activateCardAndCollapse(anchor) {
      const anchorElement = document.getElementById(anchor);

      if (this.isValidAnchor(anchorElement) == false) {
        return;
      }

      const card = this.getCardFromAnchorElement(anchorElement);
      this.activateCard(card);
      card.querySelector('a').focus();

      if (anchorElement == null || anchorElement.classList.contains('resource-title') == false) {
        return;
      }

      let collapseId = anchor.replace('resource', 'access');
      let collapse = document.getElementById(collapseId);
      this.activateResourceCollapse(collapse);
    },

    activateCard: function(card) {
      if (card == null) {
        return;
      }
    
      this.addTemporaryActive(card);  
    },

    activateResourceCollapse: function(collapse) {
      if (collapse == null) {
        return;
      }
      $(collapse).collapse('show');

      this.toggleIcon(collapse);

      let card = collapse.closest('.resource-card');
      this.activateCard(card);
    },


    activateSamePageAnchor: function(anchor) {
      if (anchor == undefined) {
        return;
      }

      this.activateCardAndCollapse(anchor);

      // close mobile nav collapse
      const resourcesMobile = document.getElementById('resources-mobile');
      this.hideResourcesMobile(resourcesMobile);
    },

    addTemporaryActive: function(element) {
      element.classList.add('active');

      setTimeout(() => {
        element.classList.remove('active');
      }, 5000);
    },

    anchorRedirect: function(selectValue) {
      let anchor;

      // selectValue may just be anchor to same page
      if (selectValue.indexOf('goto') == 0 || selectValue.indexOf('resource') == 0) {
        anchor = selectValue;
        window.location.href = '#' + selectValue;
        this.activateSamePageAnchor(anchor);

      } else {

        // may be using takeover nav and selectValue is full URL but already on digital library page
        if (window.location.pathname == '/digital-library') {
          anchor = selectValue.replace('/digital-library#', '');
          window.location.href = '#' + anchor;
          this.activateSamePageAnchor(anchor);

        } else {

          // or selectValue may be redirect from one page to Digital Library page
          anchor = this.getAnchorFromUrl(selectValue);
          window.location.href = selectValue;
        }
      }

    },

    getAnchorFromUrl: function(url) {
      const anchorPattern = /#(.*)/;
      const match = url.match(anchorPattern);

      if (!anchorPattern.test(url)) {
        return;
      }

      const anchor = match[1];
      return anchor;
    },

    // fires when new page loads
    focusAnchorOnNewPageLoad: function() {
      const url = window.location.href;
      const anchor = this.getAnchorFromUrl(url);
      const anchorElement = document.getElementById(anchor);

      if (this.isValidAnchor(anchorElement) === false) {
        return;
      }

      let card = this.getCardFromAnchorElement(anchorElement);

      var cardObserver = new IntersectionObserver((entries) => {
          cardObserverCallback(entries, cardObserver, card);
      });
      cardObserver.observe(card);

      // use observer to activate elements only when actually in view
      const cardObserverCallback = (entries, observer, element) => {
        entries.forEach((entry, intersectingElement) => {
          if (entry.isIntersecting) {
            let card = entry.target;
            this.activateCardAndCollapse(anchor);
            cardObserver.unobserve(card);
          }
        });
      };
    },

    getCardFromAnchorElement: function(anchorElement) {
      let card = anchorElement;

      // if linking to resource directly, get the parent card instead
      if (anchorElement.classList.contains('resource-title') == false) {
        return card;
      }

      card = anchorElement.closest('.resource-card');
    
      return card;
    },

    hideResourcesMobile: function(resourcesMobile) {
      if (resourcesMobile == null) {
        return;
      }

      $(resourcesMobile).collapse('hide');
    },

    initializeSamePageAnchorLinks() {
      const links = document.querySelectorAll('a');
      if (links.length <= 0) {
        return;
      }

      links.forEach((link) => {
        let href = link.getAttribute('href');

        if (href == null) {
          return;
        }

        let currentUrl = window.location.pathname;
        if (href.indexOf(currentUrl) != 0 || href.indexOf('#') == -1) {
          return;
        }

        let anchor = href.replace(window.location.pathname, '').replace('#', '');
        link.addEventListener('click', (e) => {
          this.activateSamePageAnchor(anchor);

          //close any takeovers
          Drupal.behaviors.weaver_takeover.closeAll();
        });
      });
    },

    initializeSwitchers: function() {
      // Digital library switchers from takeovers and from navigation along bottom of digital library page
      const selectSwitchers = document.querySelectorAll('.nvcl-switcher select');

      if (selectSwitchers.length <= 0) {
        return;
      }

      selectSwitchers.forEach((selectSwitcher) => {
        selectSwitcher.addEventListener('change', (e) => {
          this.switcherAction(selectSwitcher);
        });
      });

      // News switchers
      const categorySwitchers = document.querySelectorAll('.nvcl-category-switcher');
      
      if (categorySwitchers.length <= 0) {
        return;
      }
      
      categorySwitchers.forEach((categorySwitcher) => {
        categorySwitcher.addEventListener('change', (e) => {
          let selectValue = categorySwitcher.options[categorySwitcher.selectedIndex].value;
          window.location.href = '/taxonomy/term/' + selectValue;
        });
      });
    },

    isValidAnchor: function(anchorElement) {
      if (anchorElement == null) {
        return false;
      }

      if (anchorElement.classList.contains('resource-card') == false && anchorElement.classList.contains('resource-title') == false
      ) {
        return false;
      }

      return true;
    },

    switcherAction: function(switcher) {
      let selectValue = switcher.options[switcher.selectedIndex].value;

      this.anchorRedirect(selectValue);

      //close any takeovers
      Drupal.behaviors.weaver_takeover.closeAll();
    },

    toggleIcon: function(collapse) {
      let collapseTrigger = collapse.parentNode.querySelector('[data-target="#' + collapse.getAttribute('id') + '"]');
      if (collapseTrigger == null) {
        return;
      }

      Drupal.behaviors.weaver.toggleIcons(collapseTrigger);
    },

    attach: function (context, settings) {

      $(once('weaver_switchers', 'body', context)).each(function () {
        const weaver_switchers = Drupal.behaviors.weaver_switchers;

        weaver_switchers.focusAnchorOnNewPageLoad();
        weaver_switchers.initializeSamePageAnchorLinks();
        weaver_switchers.initializeSwitchers();
      });
    }
  };
})(jQuery, Drupal, once);